import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import Typography from 'apollo-react/components/Typography';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import ReactResizeDetector from 'react-resize-detector';

import BackButton from '../../../components/buttons/BackButton';
import Layout from '../../../components/Layout';
import PageContainer from '../../../components/PageContainer';
import { MIN_HEADER_HEIGHT, PAGE_CONTAINER_PADDINGS } from '../../../constants/PowerBIConstants';
import { PILGRIM_TOP_MENU_HEIGHT } from '../../../constants/SizeConstants';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { getRefreshDate } from '../../../selectors/PowerBISelectors';
import { DATE_FORMAT_WITH_MINUTES_TIMESTAMP } from '../../../utils/dateUtils';

const useStyles = makeStyles({
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '5px !important',
  },
  titleContainer: {
    flex: '1 1 100%',
    height: '100%',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  reportContainer: {
    flexWrap: 'wrap',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    height: ({ headerHeight }) => `calc(100vh - ${headerHeight}px)`,
  },
  buttonsContainer: {
    display: 'flex',
  },
});

const PowerBIPageLayout = ({ pageTitle, headerHeight, setHeaderHeight, children }) => {
  const translateString = useTranslation();
  const classes = useStyles({ headerHeight });

  const refreshDate = useSelector(getRefreshDate);

  const refreshDateToDisplay = refreshDate
    ? moment(refreshDate).format(DATE_FORMAT_WITH_MINUTES_TIMESTAMP)
    : '';

  const handleHeightChange = (pageHeaderHeight) => {
    const subtractHeight = pageHeaderHeight + PILGRIM_TOP_MENU_HEIGHT + PAGE_CONTAINER_PADDINGS;

    if (subtractHeight > MIN_HEADER_HEIGHT) {
      setHeaderHeight(subtractHeight);
    }
  };

  return (
    <Layout>
      <PageContainer>
        <Grid container spacing={1}>
          <Grid item xs={12} className={classes.headerContainer}>
            <div className={classes.titleContainer}>
              <Typography variant="h2">{pageTitle}</Typography>
              {refreshDateToDisplay && (
                <Typography>
                  {`${translateString('Last Refresh Date')}: ${refreshDateToDisplay}`}
                </Typography>
              )}
            </div>
            <div className={classes.buttonsContainer}>
              <BackButton isPowerBIPage />
            </div>
            <ReactResizeDetector handleHeight onResize={(w, h) => handleHeightChange(h)} />
          </Grid>
          <Grid item xs={12} className={classes.reportContainer}>
            {children}
          </Grid>
        </Grid>
      </PageContainer>
    </Layout>
  );
};

export default PowerBIPageLayout;
